import { Flex } from 'antd'
import { FC, ReactNode } from 'react'
import ColorProofIndicator from '../color-proof-indicator/color-proof-indicator'
import type { ShipmentType } from '../../types/api/shipment-type'

interface ColorProofNumberProps {
    children: ReactNode
    shipmentType?: ShipmentType | null
}

/** Номер + иконка ЦП, если отгрузка — цветопроба. */
const ColorProofNumber: FC<ColorProofNumberProps> = ({ children, shipmentType }) => (
    <Flex align='center' gap={4}>
        <span>{children}</span>
        {shipmentType === 'colorProof' && <ColorProofIndicator />}
    </Flex>
)

export default ColorProofNumber
